module.exports = __webpack_public_path__ + "img/img1111.da886754.jpg";